import App from "../../../App"
import Panel from "../../../component/visible/Panel"
import SimpleBanner from "../../../component/visible/SimpleBanner"
import Message from '../../../../class/FrameMessage'
import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate"
import i18nTools from '../../../../common/local/format'

export default class DialogBanner extends SingleOfferTemplate {
    constructor(...props) {
        super(...props)
    }

    initComponents() {
        super.initComponents()

        this.banner = new SimpleBanner({
            icon: this.campaign.icon_url,
            ad:false,
            buttonText: i18nTools.formatByUA('_switch_one'),
            title: this.campaign.title,
            star: this.campaign.rating,
            iconShape:"circle",
            iconSize:"1",
            theme:"transparent",
            onButtonClick: () => {
                const sendData = {
                    instanceId: App.rootWebviewId,
                    campaign: this.campaign,
                }
                Message.emitMessageToSuperView('onInstallBtnClick', sendData)
            },
        })
        this.panel = new Panel({
            width: '100%',
            title: i18nTools.formatByUA('_not_interested_in_this_video', {second: ''}),
            titleClassName: ['dialog-title','mtg-color-white'],
            titleToolsClassName: ['top-align'],
            titleTools:[{
                type: 'flatClose',
                theme: 'black',
                onClick: () => {
                    const sendData = {
                        instanceId: App.rootWebviewId,
                        campaign: this.campaign,
                    }
                    Message.emitMessageToSuperView('onCloseBtnClick', sendData)
                }
            }],
            content: this.banner,
        })

        this.panel.appendTo(document.querySelector('.page-container'))
        this.panel.show()
    }

    bindEvent() {
        super.bindEvent()
        Message.onSuperViewEmitMessage('updateTitleCountdown', (data) => {
            const text = i18nTools.formatByUA('_not_interested_in_this_video', {
                second:  data.remainSecond + 's'
            })
            this.panel.setTitle(text)
        })
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.panel && this.panel.destory()
        this.banner && this.banner.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        const promise = super._isLoadFinish()
        promise.then(() => {
            console.log('dialogBanner load 成功')
        }).catch(e=>{
            console.log('dialogBanner load 失败', e)
        })
        return promise
    }
}